import axios from '../helpers/axios'
import { logError } from '../services';
import qs from 'querystring';
import {
  IDocumentTemplateRes,
  IDocumentTemplateRole,
  IPostTemplateData,
  IReplacementField,
  IAvailableTemplateTypes
} from './../models/templates';

export const getTemplates = async (filters?: {
  search?: string;
  vendorTypeId?: string | number;
  subcontractorTypeId?: string | number;
  vendorId?: string | number;
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  isGenericTemplate?: boolean;
  hasInprogressDocuments?: boolean;
  type?: string;
}): Promise<IDocumentTemplateRes> => {
  try {
    const { data } = await axios.get(`/api/templates`, {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error) {
    logError(error, 'getTemplates failed');
    return Promise.reject(error);
  }
};

export const getVendorTemplates = async (filters?: {
  search?: string;
  vendorTypeId?: string | number;
  subcontractorTypeId?: string | number;
  vendorId?: string | number;
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  isGenericTemplate?: boolean;
  hasInprogressDocuments?: boolean;
  type?: string;
}): Promise<IDocumentTemplateRes> => {
  try {
    const { data } = await axios.get(`/api/vendors/templates`, {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error) {
    logError(error, 'getVendorTemplates failed');
    return Promise.reject(error);
  }
};

export const getReplacementFields = async (): Promise<IReplacementField[]> => {
  try {
    const { data } = await axios.get(`/api/templates/replacement-fields`, {});
    return data;
  } catch (error) {
    logError(error, 'getReplacementFields failed');
    return Promise.reject(error);
  }
};
export const getDocumentTemplateRoles = async (): Promise<IDocumentTemplateRole[]> => {
  try {
    const { data } = await axios.get(`/api/templates/roles`, {});
    return data;
  } catch (error) {
    logError(error, 'getDocumentTemplateRoles failed');
    return Promise.reject(error);
  }
};
export const createTemplate = async (
  templateData: IPostTemplateData
): Promise<IDocumentTemplateRes> => {
  try {
    const { data } = await axios.post(`/api/templates`, templateData);
    return data;
  } catch (error) {
    logError({ error, payload: templateData }, 'createTemplate failed');
    return Promise.reject(error?.response?.data);
  }
};

export const updateTemplate = async (
  templateData: IPostTemplateData
): Promise<IDocumentTemplateRes> => {
  try {
    const { data } = await axios.put(`/api/templates`, templateData);
    return data;
  } catch (error) {
    logError({ error, payload: templateData }, 'updateTemplate failed');
    return Promise.reject(error?.response?.data);
  }
};

export const deleteTemplate = async (pandaDocTemplateId: string | number): Promise<any> => {
  try {
    const { data } = await axios.delete(`/api/templates/${pandaDocTemplateId}`);
    return data;
  } catch (error) {
    logError({ error, payload: pandaDocTemplateId }, 'deleteTemplate failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getAvailableTemplateTypes = async (filters?: {
  pandaDocTemplateId?: string;
}): Promise<IAvailableTemplateTypes[]> => {
  try {
    const { data } = await axios.get(`/api/templates/available-template-types`, {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error) {
    logError(error, 'getAvailableTemplateTypes failed');
    return Promise.reject(error);
  }
};
